<template>
  <v-btn
    class="bottom-button"
    @click="goToRoute"
    :active="isActive"
  >
    <v-icon class="bottom-icon">{{ icon }}</v-icon>
    {{ label }}
  </v-btn>
</template>
<script setup>
import { computed, toRefs } from 'vue';
import { useRouter } from 'vue-router';

const props = defineProps({
  routes: {
    type: Array,
    default: () => [],
  },
  route: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
});
const { route, routes, icon, label } = toRefs(props);
const router = useRouter();

function goToRoute() {
  const r = routes.value.find((item) => item.menuPath === route.value);
  if (r) {
    router.push(r.path);
  }
  else {
    window.location.href = route.value;
  }
}

const isActive = computed(() => {
  const base = import.meta.env.BASE_URL === '/' ? '' : import.meta.env.BASE_URL;
  return `${base}${router.currentRoute.value.path}` === route.value;
});

</script>
<style scoped>
.bottom-button {
  min-width: unset !important;
  max-width: unset !important;
  padding: 0px !important;
  font-size: 0.6875rem !important;
  font-weight: 400;
  flex: 1 1 0;
}
.bottom-icon {
  font-size: 28px;
}
</style>